import React from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsReact from "highcharts-react-official";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import Loader from "../../../components/Loader";

// if (typeof Highcharts === "object") {
//   Highcharts3D(Highcharts);
// }

const SalesVsRealization = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const {
    data: salesVsRealizationData = [],
    isLoading: salesVsRealizationIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "sales_vs_realisation",
    lang: languageType,
  });

  const options = {
    chart: {
      type: "column",
      options3d: {
        enabled: true,
        alpha: 35,
        beta: 0,
        depth: 75,
        viewDistance: 125,
      },
    },
    title: {
      text: getText("Sales vs Realisation", "बिक्री बनाम वास्तविकता"),
      align: "left",
    },
    subtitle: {
      // text:
      //   'Source: <a target="_blank" ' +
      //   'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>',
      align: "left",
    },
    xAxis: {
      // categories: ["2016-17", "2017-18", "2018-19"],
      categories: salesVsRealizationData?.map(
        (item) => item?.field_sales_vs_realisation ?? null
      ),
      crosshair: true,
      accessibility: {
        description: "Countries",
      },
    },
    yAxis: {
      min: 1200,
      tickInterval: 200,
      title: {
        text: getText("In Crores", "करोड़ों में"),
      },
    },
    tooltip: {
      valueSuffix: " Crore",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.0,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: getText("Sales (in Cr)", "बिक्री (करोड़ में)"),
        // data: [1404, 1633, 2007],
        data: salesVsRealizationData?.map(
          (item) => parseInt(item?.field_sales_in_crs) ?? null
        ),
      },
      {
        name: getText("Realisation (in Cr)", "प्राप्ति (करोड़ में)"),
        // data: [1946, 1685, 1860],
        data: salesVsRealizationData?.map(
          (item) => parseInt(item?.field_realisation_in_csr) ?? null
        ),
      },
    ],
  };

  if (salesVsRealizationIsLoading) {
    return <Loader />;
  }

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default SalesVsRealization;
